import { CardCharge } from '@anm/api/modules/subscription';
import SubscriptionHistoryBlock from '@anm/components/subscription/history/SubscriptionHistoryBlock';
import { SubscriptionHistoryItemProps } from '@anm/components/subscription/history/SubscriptionHistoryItem';
import usePending from '@anm/hooks/usePending';
import { shallowEqual, useSelector } from 'react-redux';

import vtConfig from '../../../config';
import useFetchSubscriptionHistory from '../../../hooks/subscription/useFetchSubscriptionHistory';
import { subscriptionSelectors } from '../../../store/modules/subscription';

const {
  urls: { apiWave }
} = vtConfig();

const mapCardChargesToHistoryItemProps = (
  chargesList: CardCharge[]
): SubscriptionHistoryItemProps[] =>
  chargesList.map(
    ({
      id,
      date,
      amount,
      'card-type': cardType,
      'card-last4': last4,
      status
    }) => ({
      id,
      date,
      last4,
      amount,
      status,
      cardType,
      apiDomain: apiWave
    })
  );

const UserInvoiceHistory = () => {
  const isHistoryPending = useSelector(
    subscriptionSelectors.selectHistoryPending
  );
  const isPending = usePending(isHistoryPending);
  const chargesList = useSelector(
    subscriptionSelectors.selectCardCharges,
    shallowEqual
  );

  useFetchSubscriptionHistory();

  return (
    <SubscriptionHistoryBlock
      list={chargesList && mapCardChargesToHistoryItemProps(chargesList)}
      isPending={isPending}
    />
  );
};

export default UserInvoiceHistory;
